import api from "./api";

export async function getDashboardUser(id) {
    return api.get(`/dashboardUsers/${id}`)
        .then(response => response.data)
        .catch(error => console.log(error.response));
}

export async function getDashboardUsers(paginate = false, page = 1, profile= '') {
    return api.get(`/dashboardUsers?paginate=${paginate}&page=${page}&profile=${profile}`)
        .then(response => response.data)
        .catch(error => console.log(error.response));
}

export async function setUsersDashboard(data) {
    return api.post("/dashboardUsers", data)
        .then(response => response.data)
        .catch(error => console.log(error.response));
}

export async function updateUsersDashboard(id, data) {
    return api.put(`/dashboardUsers/${id}`, data)
        .then(response => response.data)
        .catch(error => console.log(error));
}

export async function deleteUsersDashboard(id) {
    return api.delete(`/dashboardUsers/${id}`)
        .then(response => response.data)
        .catch(error => console.log(error));
}
